import { makeStyles, Theme } from '@material-ui/core';

export const useNftCollectionDelailsStyle = makeStyles<Theme>((theme) => ({
  nftsWrapper: {
    marginTop: '40px',
    padding: '0 0',
    [theme.breakpoints.down('md')]: {
      padding: '0 16px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '0 16px',
      marginTop: '24px',
    },
  },
  nftsHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: '32px',
    [theme.breakpoints.down('xs')]: {
      marginBottom: '24px',
    },

    '& > h2': {
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: '32px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '20px',
        lineHeight: '20px',
      },
    },
  },
  nftTitleInfoWrap: {
    display: 'flex',
  },
  btnBack: {
    width: '34px',
    height: '34px',
    background: '#FFFFFF1A',
    borderRadius: '4px',
    marginRight: '16px',
    cursor: 'pointer',
    '& > img': {},
  },
  nftTitleInfo: {
    '& > h2': {
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: '32px',
      color: '#FAFAFA',
      marginBottom: '12px',
      [theme.breakpoints.down('xs')]: {
        fontSize: '20px',
        lineHeight: '20px',
      },
    },
    '& > span': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      color: '#949494',
    },
  },
  nftItems: {},
  nftItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    flex: '0 1 calc( ( 100% - 128px ) / 5 )',
    [theme.breakpoints.down('xs')]: {
      flex: '0 0 calc(50% - 12px)',
    },
    '& > img': {
      borderRadius: '12px',
      marginBottom: '12px',
      maxWidth: '100%',
    },
    '& > h5': {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '24px',
    },
    '&:hover > div': {
      visibility: 'visible',
      opacity: '1',
      top: '50%',
    },
  },
  btnNftWithdraw: {
    visibility: 'hidden',
    background: '#FAFAFA',
    color: '#000000',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 12px',
    gap: '4px',
    boxShadow: '0px 4px 12px #00000040',
    borderRadius: '56px',
    transition: 'all 200ms ease-in',
    position: 'absolute',
    opacity: '0',
    top: '80%',
    cursor: 'pointer',
    zIndex: 2,
  },
  navRoot: {
    display: 'flex',
    justifyContent: 'flex-end',
    '&& *': {
      color: '#FFFFFF',
    },
    '&& .MuiPaginationItem-page': {
      background: 'rgba(255, 255, 255, 0.1)',
      borderRadius: 4,
    },
    '&& .Mui-selected': {
      background: 'linear-gradient(90deg, #574aea 0%, #986bf9 100%)',
      borderRadius: 4,
    },
  },
  nftsItems: {
    display: 'flex',
    alignItems: 'center',
  },
  spinner: {
    margin: '20px auto',
  },
}));
